import { useEffect, useState } from 'react';
import useUserMemory from '../use-user-memory';
import { tagService } from '../../queries/tag';

export const enum TAG_TYPE {
  DISCIPLINA = 'DISCIPLINA',
  MODULO = 'MODULO',
  ASSUNTO = 'ASSUNTO',
  AREA_PROVA = 'AREA_PROVA',
}

const useSubjects = (disciplineUuid?: string) => {
  const { memoryUserUuid } = useUserMemory();
  const userUuid = memoryUserUuid;

  const [subjects, setTags] = useState<Tag[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchSubjects = async (disciplineUuidParam?: string) => {
    const disciplineToRequest = disciplineUuidParam || disciplineUuid;
    if (!userUuid) return;
    try {
      setIsLoading(true);
      const tags = await tagService.listSubjects(userUuid, disciplineToRequest);
      setTags(tags);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, [userUuid, disciplineUuid]);

  return {
    subjects,
    fetchSubjects,
    isLoading,
  };
};

export default useSubjects;
